import {pxToRem} from '../../../utills/pxToRem'
import {fonts} from '../../foundations/fonts'

export default {
    baseStyle: () => ({
        container: {
            position: 'relative'
        },
        favIcon: {
            position: 'absolute',
            variant: 'unstyled',
            top: 2,
            right: 2
        },
        imageWrapper: {
            position: 'relative',
            marginBottom: 3,

            _hover: {
                '.qv-btn': {
                    display: 'block'
                }
            },

            '.qv-btn': {
                position: 'absolute',
                bottom: '0',
                display: 'none'
            }
        },
        quickViewBtn: {
            position: 'absolute',
            bottom: 0,
            display: 'none'
        },
        image: {
            ratio: 1,

            sx: {
                img: {
                    objectFit: 'unset'
                }
            }
        },
        link: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            _hover: {
                textDecoration: 'none'
            }
        },
        price: {
            fontFamily: fonts.primary,
            fontSize: [pxToRem(12), pxToRem(13)],
            fontWeight: 400,
            letterSpacing: pxToRem(1),
            marginTop: 'auto',
            color: 'black'
        },
        currentPrice: {
            color: 'cav_calltoaction_darkred',
            fontWeight: 500
        },
        title: {
            color: 'black',
            fontFamily: fonts.primary,
            fontSize: [pxToRem(12), pxToRem(13)],
            fontWeight: 400,
            letterSpacing: pxToRem(1),
            marginBlock: [pxToRem(5), pxToRem(15)]
        },
        rating: {},
        variations: {},
        badgeGroup: {
            position: 'absolute',
            top: 2,
            left: 2
        },
        promoCallout: {
            color: 'cav_calltoaction_darkred',
            fontFamily: fonts.primary,
            fontSize: [pxToRem(10), pxToRem(12)],
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: pxToRem(1),
            textTransform: 'uppercase',

            sx: {
                a: {
                    color: 'cav_calltoaction_darkred'
                }
            }
        }
    }),
    parts: [
        'container',
        'imageWrapper',
        'image',
        'price',
        'currentPrice',
        'title',
        'rating',
        'variations',
        'badgeGroup',
        'promoCallout',
        'quickViewBtn'
    ]
}
